import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78f52988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-stat" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invest-stat-m" }, "~", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_4 = { class: "invest-stat" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-stat-title" }, "参与者数据汇总分析", -1))
const _hoisted_6 = {
  class: "invest-stat-tx",
  id: "main1"
}
const _hoisted_7 = {
  class: "invest-stat-tx",
  id: "main2"
}
const _hoisted_8 = {
  class: "invest-stat-tx",
  id: "main3"
}
const _hoisted_9 = {
  class: "invest-stat-tx",
  id: "main4"
}

import { onMounted, ref } from 'vue'
import * as echarts from 'echarts/core';
import { 
  GridComponent, 
  GridComponentOption,
  TitleComponent,
  TooltipComponent,
  LegendComponent 
} from 'echarts/components';
import { 
  BarChart, 
  BarSeriesOption,
  PieChart,
  LineChart,
  TreemapChart
} from 'echarts/charts';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

echarts.use([
  GridComponent, 
  BarChart, 
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  LabelLayout,
  LineChart, 
  UniversalTransition,
  TreemapChart,
]);

const value1 = ref('')
const value2 = ref('')
const echartIndex = ref (1)

const tabs = ref([
  {
    title: '表格图',
    name: 0
  },
  {
    title: '柱形图',
    name: 1
  },
  {
    title: '折线图',
    name: 2
  },
  {
    title: '分布图',
    name: 3
  }
])

const search1 = ref(['活动1标题'])
const condition1 = ['活动1标题', '活动2标题', '活动3标题', '活动4标题']

const search2 = ref(['进行中'])
const condition2 = ['报名中', '进行中', '已完成']

const search3 = ref(['品牌经销商'])
const condition3 = ['地产物业', '品牌厂家', '品牌经销商', '非会员']

const search4 = ref(['已审核的'])
const condition4 = ['已审核的', '待审核的']

onMounted(() => {
  tx1()
  tx2()
  tx3()
  tx4()
}) 

const tx1 = () => {
  var chartDom = document.getElementById('main1')!;
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    series: [
      {
        type: 'treemap',
        data: [
          {
            name: 'nodeA',
            value: 10,
            children: [
              {
                name: 'nodeAa',
                value: 4
              },
              {
                name: 'nodeAb',
                value: 6
              }
            ]
          },
          {
            name: 'nodeB',
            value: 20,
            children: [
              {
                name: 'nodeBa',
                value: 20,
                children: [
                  {
                    name: 'nodeBa1',
                    value: 20
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  };

  option && myChart.setOption(option);
}

const tx2 = () => {
  type EChartsOption2 = echarts.ComposeOption<
    GridComponentOption | BarSeriesOption
  >;

  const chartDom2 = document.getElementById('main2')!;
  const myChart2 = echarts.init(chartDom2);
  let option2: EChartsOption2;

  option2 = {
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: [120, 200, 150, 80, 70, 110, 130],
        type: 'bar'
      }
    ]
  };

  option2 && myChart2.setOption(option2);
}

const tx3 = () => {
  var chartDom3 = document.getElementById('main3')!;
  var myChart3 = echarts.init(chartDom3);
  var option3;

  option3 = {
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line',
        areaStyle: {}
      }
    ]
  };

  option3 && myChart3.setOption(option3);
}

const tx4 = () => {

  var chartDom4 = document.getElementById('main4')!;
  var myChart4 = echarts.init(chartDom4);
  var option4;

  option4 = {
    title: {
      text: 'Referer of a Website',
      subtext: 'Fake Data',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        data: [
          { value: 1048, name: 'Search Engine' },
          { value: 735, name: 'Direct' },
          { value: 580, name: 'Email' },
          { value: 484, name: 'Union Ads' },
          { value: 300, name: 'Video Ads' }
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  option4 && myChart4.setOption(option4);
}
  

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "invest-stat-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "项目名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: search1.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search1).value = $event)),
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(condition1, (city) => {
                      return _createVNode(_component_el_checkbox_button, {
                        key: city,
                        label: city
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(city), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "项目状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: search2.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search2).value = $event)),
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(condition2, (city) => {
                      return _createVNode(_component_el_checkbox_button, {
                        key: city,
                        label: city
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(city), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "报名者" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: search3.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search3).value = $event)),
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(condition3, (city) => {
                      return _createVNode(_component_el_checkbox_button, {
                        key: city,
                        label: city
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(city), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "报名状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: search4.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search4).value = $event)),
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(condition4, (city) => {
                      return _createVNode(_component_el_checkbox_button, {
                        key: city,
                        label: city
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(city), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "统计周期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "invest-stat-picker",
                  modelValue: value1.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((value1).value = $event)),
                  type: "date",
                  placeholder: "Pick a day"
                }, null, 8, ["modelValue"]),
                _hoisted_2,
                _createVNode(_component_el_date_picker, {
                  class: "invest-stat-picker",
                  modelValue: value2.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((value2).value = $event)),
                  type: "date",
                  placeholder: "Pick a day"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  class: "invest-stat-search-btn",
                  type: "primary",
                  size: "large",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_el_tabs, {
        class: "invest-stat-tabs",
        modelValue: echartIndex.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((echartIndex).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              label: item.title,
              name: item.name
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
          [_vShow, echartIndex.value == 0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
          [_vShow, echartIndex.value == 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
          [_vShow, echartIndex.value == 2]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
          [_vShow, echartIndex.value == 3]
        ])
      ])
    ])
  ]))
}
}

})